import React, { FC } from 'react';
import Tooltip from 'react-tooltip';
import { FormattedMessage, injectIntl } from 'react-intl';
import { isTouchDevice } from '../../../utils/domUtils';
import styles from './who_can_see_this.module.scss';
import { InjectedIntlProps } from '../../../doctrine.types';

export const RawWhoCanSeeThis: FC<InjectedIntlProps> = ({ intl }) => {
  if (isTouchDevice()) return null;
  return (
    <div className={styles.container}>
      <span
        className={styles.text}
        data-tip={intl.formatMessage({
          id: 'entity/expertises/WhoCanSeeThis.tsx/2',
        })}
        data-for="who-can-see-this"
      >
        <FormattedMessage id="entity/expertises/WhoCanSeeThis.tsx/1" />
      </span>
      <Tooltip id="who-can-see-this" effect="solid" />
    </div>
  );
};

export const WhoCanSeeThis = injectIntl(RawWhoCanSeeThis);
